const DEFAULT_AQUISITION_ISSUE = 'dmc-support2';
const GENERAL_ADVERTISER_SUPPORT_ISSUE = 'advertiser-support2';

const DEFAULT_PRODUCT = 'BingAds';
const DEFAULT_SOURCE = 'Copilot';
const DEFAULT_FLOW_ID = 'MAP-Signup-StartLiveChat';

const NON_ACQUISITION_LOCALES = new Set([
  'nl-nl', 'fr-ca', 'fr-fr',
  'de-at', 'de-de', 'de-ch',
  'it-it', 'pt-br',
  'es-ar', 'es-cl', 'es-co', 'es-mx', 'es-pe', 'es-es', 'es-ve',
  'ja-jp',
]);

const createCustomContextValue = value => ({
  value,
  isDisplayable: true,
});

const normalizeLocale = (locale) => {
  const normalizedLocale = locale.toLowerCase();
  return normalizedLocale === 'en' ? 'en-us' : normalizedLocale;
};

const getQueue = (locale) => {
  const normalized = normalizeLocale(locale);
  return NON_ACQUISITION_LOCALES.has(normalized) ? 'general' : 'acquisition';
};

export const createLiveAgentCustomContext = ({
  email, firstName, lastName, locale,
}) => {
  const normalized = normalizeLocale(locale);
  const issue = NON_ACQUISITION_LOCALES.has(normalized)
    ? GENERAL_ADVERTISER_SUPPORT_ISSUE
    : DEFAULT_AQUISITION_ISSUE;
  const queue = getQueue(normalized);

  return {
    Product: createCustomContextValue(DEFAULT_PRODUCT),
    Locale: createCustomContextValue(normalized),
    Issue: createCustomContextValue(issue),
    Source: createCustomContextValue(DEFAULT_SOURCE),
    FlowID: createCustomContextValue(DEFAULT_FLOW_ID),
    Queue: createCustomContextValue(queue),
    Email: createCustomContextValue(email),
    FirstName: createCustomContextValue(firstName),
    LastName: createCustomContextValue(lastName),
  };
};

export const LIVE_AGENT_ONLY_MODE_CONNECTION_DESCRIPTION =
  _TL_('Copilot was not involved in the conversation flow. The user initiated a live chat request from the sign-up process while creating a new Microsoft Advertising account and needs assistance from a human agent.');
